module.exports = __webpack_public_path__ + "img/materials.afb7f2f9.svg";